'use client';

import { ReactNode } from 'react';
import classnames from 'classnames';

interface Props {
  children: ReactNode;
  disabled: boolean;
}

const Upload = ({ children, disabled }: Props) => {
  const className = classnames({
    'border-dashed': true,
    'border-4': true,
    'border-upload-color': true,
    'text-upload-color': true,
    '!p-8': true,
    'text-center': true,
    'cursor-pointer': true,
    'bg-card-background-color': true,
    'border-upload-disabled-color': disabled,
    'text-upload-disabled-color': disabled,
    'cursor-auto': disabled,
  });

  return <div className={className}>{children}</div>;
};

export default Upload;
